import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card} from 'semantic-ui-react';
import {FormattedNumber} from "react-intl";
import {selectPrice} from "../../actions/PricesActions";

class PriceCard extends Component {

    render() {
        let price = (this.props.plan_price * this.props.months) - ((this.props.plan_price * this.props.months)*this.props.discount)/100;

        return (
            <Card onClick={() => this.props.selectPrice(this.props)}>
                <Card.Header textAlign={'center'}
                             className={this.props.price.id === this.props.id ? 'headerPriceSelected' : 'headerPrice'}>
                    {this.props.months} {this.props.months === 1 ? 'Mes' : 'Meses'}
                </Card.Header>
                <Card.Content textAlign={'center'}>
                    <Card.Header textAlign={'center'} className={'titlePrice'}>
                        $<FormattedNumber value={price} currency="USD" maximumFractionDigits={0}
                                          minimumFractionDigits={0}/>
                    </Card.Header>
                </Card.Content>
                <Card.Content extra textAlign='center'>
                    {this.props.months === 1 ? 'Precio Normal' : `${this.props.discount}% de descuento`}
                </Card.Content>
            </Card>
        );
    }
};

const mapStateToProps = state => {
    return{
        price: state.get('price')
    };
};

const mapDispatchToProps = dispatch => {
    return {
        selectPrice(price) {
            dispatch(selectPrice(price));
        }
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PriceCard);



// WEBPACK FOOTER //
// ./src/components/settings/PriceCard.js